export const blockIconsHouseholdGarageHomeNew = (
	<span className='material-symbols-outlined'>garage_home</span>
);
